var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBulletListStroke = function SvgIconBulletListStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    d: "M3 17a2 2 0 1 1 .001 3.999A2 2 0 0 1 3 17m20 2.85H7.3v-1.7H23zM3 10a2 2 0 1 1 .001 3.999A2 2 0 0 1 3 10m20 2.85H7.3v-1.7H23zM3 3a2 2 0 1 1 .001 3.999A2 2 0 0 1 3 3m20 2.85H7.3v-1.7H23z"
  })));
};
export default SvgIconBulletListStroke;